var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef } from "react";
import ReactDOM, { unmountComponentAtNode } from 'react-dom';
import get from "lodash/get";
import pick from "lodash/pick";
import fromEntries from "lodash/fromPairs";
import { useSelector } from "react-redux";
import { createDomElement } from ".";
import { getInitialData } from "../store/actions/response.actions";
import { App } from '../App';
import { getResponseManager } from "../responseManager/BeeResponseManager";
import { useIntegrationName } from "./useIntegrationName";
import { isAdminIntegration } from "../store/statePresenter";
import { AppContext, useAppContext, useConfig } from "../AppContext";
import { defaultIntegrationName } from "../httpService";
import { getAppContext, getIntegrationURL } from "../store/stateGetter";
import { ERoute } from "./Routes";
import { bookingformParams } from "./supportedParameters";
var findParentAnchor = function (el) {
    var _a;
    if (!el)
        return null;
    if (((_a = el.nodeName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "a")
        return el;
    return findParentAnchor(el.parentNode);
};
/**
 * Add event listener
 * Show popup for quick book now/ add to cart
 */
export var useGlobalClickListener = function () {
    var context = useAppContext();
    var isCartDisabled = useConfig("disableCart", false)[0];
    var integrationName = useIntegrationName();
    var initialData = useSelector(function (state) { var _a; return (_a = getInitialData(get(state, "responseReducer"))) === null || _a === void 0 ? void 0 : _a.response; });
    var integrationUrl = useSelector(function (state) { return getIntegrationURL(state); });
    var adminIntegration = useSelector(isAdminIntegration);
    var elRef = React.useRef(null);
    var apiBaseUrl = useSelector(function (state) { var _a; return (_a = getAppContext(state)) === null || _a === void 0 ? void 0 : _a.apiBaseUrl; });
    var clickListenerRef = useRef(null);
    var clickListener = function (e) {
        var _a;
        var node = findParentAnchor(e.target);
        if ((node === null || node === void 0 ? void 0 : node.nodeName.toLowerCase()) !== "a")
            return;
        var itemIntegrationName = (_a = get(node, "dataset.integrationName")) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (itemIntegrationName ? integrationName !== itemIntegrationName : integrationName !== defaultIntegrationName)
            return;
        var shouldSkip = node.classList.contains("ws-redirect") || ["", "1", "true"].includes(node.dataset.wsRedirect) || !node.getAttribute("href");
        if (shouldSkip) {
            return;
        }
        if (node.getAttribute("href").startsWith("#")) {
            return;
        }
        // If Relative url, continue
        var href = get(node, "href", "");
        var startsWithHTTP = href.startsWith("http");
        if (!startsWithHTTP)
            return;
        // If route is not a websail route, continue
        var url = new URL(href);
        var cleanedIntegrationUrl = integrationUrl.replace(/\/?#\/?/, "#");
        if (!url.href.replace(/\/?#\/?/, "#").replace("#/", "#").startsWith(cleanedIntegrationUrl))
            return;
        if (url.hash === "" || url.hash === "#" || url.hash === "#/") {
            url.hash = "#" + ERoute.BOOKCART;
        }
        if (!url.hash.startsWith("#" + ERoute.BOOKCART)) {
            return;
        }
        // If hash doesn't contain query param, continue
        var search = fromEntries(Array.from(new URL(url.hash.replace("#", window.location.origin)).searchParams.entries()));
        var params = pick(search, bookingformParams);
        e.preventDefault();
        e.stopPropagation();
        if (elRef.current) {
            unmountComponentAtNode(elRef.current);
        }
        elRef.current = createDomElement({
            id: "ws-button-click-popup",
            el: "div",
            html: "",
        });
        elRef.current.style.display = "none";
        document.body.appendChild(elRef.current);
        var onModalClose = function () {
            if (elRef.current) {
                unmountComponentAtNode(elRef.current);
                document.body.removeChild(elRef.current);
            }
        };
        ReactDOM.render(React.createElement(AppContext.Provider, { value: context },
            React.createElement(App, { componentType: "WSADDTOCART", apiBaseUrl: apiBaseUrl, index: "add-to-cart", showPopup: true, attributes: __assign(__assign({ searchParams: search, integrationName: integrationName }, params), { timespanid: params.ftimespans }), onModalClose: onModalClose })), elRef.current);
        return false;
    };
    useEffect(function () {
        clickListenerRef.current = clickListener;
    }, [integrationUrl]);
    useEffect(function () {
        var _a;
        if (!initialData)
            return;
        if (isCartDisabled)
            return;
        var options = (_a = getResponseManager(initialData)) === null || _a === void 0 ? void 0 : _a.options();
        if (adminIntegration || !get(options, "enable_cart"))
            return;
        document.removeEventListener("click", clickListenerRef.current);
        document.addEventListener("click", clickListenerRef.current);
        return function () {
            document.removeEventListener("click", clickListenerRef.current);
        };
    }, [isCartDisabled, integrationName, integrationUrl, initialData, adminIntegration, apiBaseUrl]);
};
